import { Root } from '@radix-ui/react-label';
import { type ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from '@avanta/shared/components/Text';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { cn } from '@avanta/shared/utils/cn';

type LabelProps = ComponentProps<typeof Root> & {
  required?: boolean;
};

export const Label = ({
  className,
  required,
  children,
  ...props
}: LabelProps): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.COMMON);
  return (
    <Root
      data-slot="label"
      className={cn(
        `font-['Inter'] flex items-center gap-2 text-sm leading-none font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50`,
        required === false && 'gap-1',
        className
      )}
      {...props}
    >
      {children}
      {required === false ? (
        <Text tag="span" variant="text-sm-regular" className="text-gray-400">
          {t('Common.optional')}
        </Text>
      ) : null}
    </Root>
  );
};
